import Vue from "vue";
import Vuex from "vuex";
import CONFIG from '../configs';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    studiosDetails: [],
    studios: [],
    apprentices: [],
    artists: [],
    studiosProjects: [],
    countries: {},
    errors: {},
    hostMessage: {},
    userDetails: [],
    masters: [],
    stats: {}
  },
  getters: {
    countryOptions (state) {
      const countries = state.countries
      return Object.keys(countries).reduce((acc, curr) => {
        const country = countries[curr].country
        return { ...acc, ...{ [country]: curr } }
      }, {})
    },
    getArtists(state) {
      return state.artists
    },
    getStudiosDetails(state) {
      return state.studiosDetails
    },
    getStudiosIds(state) {
      return state.studios.reduce((acc, curr)=> {
        acc.push(curr.nid)
        return acc
      }, [])
    },
    studioProjects(state) {
      return state.studiosProjects
    }, 
    hasToken () {
      return localStorage.getItem('userToken') !== null
    },
  },
  mutations: {
    setStudios(state, payload) {
      state.studios = payload
    },
    setApprentices(state, payload) {
      state.apprentices = payload
    },
    setCountries(state, payload) {
      state.countries = payload
    },
    setErrors(state, payload) {
      state.errors = payload
    },
    setHostMessage(state, payload) {
      state.hostMessage = payload
    },
    setArtists(state, payload) {
      state.artists = payload
    },
    setStudioDetails(state, payload) {
      state.studiosDetails = payload
    },
    setMasters(state, payload) {
      state.masters = payload
    },
    setStudioProjects(state, payload) {
      state.studiosProjects = payload
    },
    setUserDetails(state, payload) {
      state.userDetails = payload 
      localStorage.setItem('userToken', JSON.stringify(payload))
    },
    setStats(state, payload) {
      state.stats = payload
    },
  },
  actions: {
    async removeToken() {
      try {
        localStorage.removeItem('userToken')
      } catch (error) {
        throw Error(error)
      }
    },
    async getCountries({ commit }) {
      try {
        const response = await CONFIG.API.get('https://api.first.org/data/v1/countries')
        if (Object.keys(response.data.data).length) {
          commit('setCountries', response.data.data)
        }
      } catch (errors) {
        throw Error(errors)
      }
    },
    async getStats({ commit }) {
      try {
        const response = await CONFIG.API.get('/attendees/stats/?_format=json')
        if (Object.keys(response.data).length) {
          commit('setStats', response.data)
        }
      } catch (errors) {
        throw Error(errors)
      }
    },
    async getHostMessage({ commit }) {
      try {
        const response = await CONFIG.API.get('/general/message-host/?_format=json')
        if (response.data.length) {
          commit('setHostMessage', response.data[0])
        }
      } catch (errors) {
        throw Error(errors)
      }
    },
    async getStudios({ commit }) {
      try {
        const response = await CONFIG.API.get('/studios/?_format=json')
        if (response.data.length) {
          commit('setStudios', response.data)
        }
      } catch (errors) {
        throw Error(errors)
      }
    },
    async getMasters({ commit }) {
      try {
        const response = await CONFIG.API.get('/masters/?_format=json')
        if (response.data.length) {
          commit('setMasters', response.data)
        }
      } catch (errors) {
        throw Error(errors)
      }
    },
    async getApprentices({ commit }) {
      try {
        const response = await CONFIG.API.get('/apprentices/?_format=json')
        if (response.data.length) {
          commit('setApprentices', response.data)
        }
      } catch (errors) {
        throw Error(errors)
      }
    },
    async getStudiosDetails({ commit }, payload) {
      try {
        const response = await CONFIG.API.get(`/studio/${payload}?_format=json`)
        if (response.data.length) {
          commit('setStudioDetails', response.data[0])
        }
      } catch (errors) {
        throw Error(errors)
      }
    },
    async getStudioArtists({ commit }, payload) {
      try {
        const response = await CONFIG.API.get(`/apprentices/studio/${payload}/?_format=json`)
        if (response.data.length) {
          commit('setArtists', response.data)
        }
      } catch (errors) {
        throw Error(errors)
      }
    },
    async getStudioProjects({ commit }, payload) {
      try {
        const response = await CONFIG.API.get(`/projects/studio/${payload}/?_format=json`)
        if (response.data.length) {
          commit('setStudioProjects', response.data)
        }
      } catch (errors) {
        throw Error(errors)
      }
    },
    async checkUser({ commit }, payload) {
      try {
        const response = await CONFIG.API.get(`/attendees/${payload}/?_format=json`)
        if (response.data.length) {
          commit('setUserDetails', response.data)
        }
        return response
      } catch (errors) {
        throw Error(errors)
      }
    },
    async webformSubmit({ commit }, payload) {
      try {
        return await CONFIG.API.post('/webform_rest/submit/?_format=json', payload, { headers: CONFIG.headers })
      } catch (errors) {
        commit('setErrors', errors.response.data.error)
        throw Error(errors)
      }
    }
  },
});
